import { InitSalesTransactionModel } from './initsales_body.model';
import { InitSalesRequestBody } from './initsales_requestBody';

export class InitSalesTransaction {
    Request: InitSalesRequestBody;
    Signature: string;

    constructor(model: InitSalesTransactionModel) {
        this.Request = model.Request;
        this.Signature = model.Signature;
    }
}
